import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import PageNotFound from '@/views/PageNotFound.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/index.html',
        component: Login,
        alias: '/'
    },
    {
        path: '/',
        name: 'login',
        component: Login,
        meta: { previewWithoutSubscription: true }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/Register.vue')
    },
    {
        path: '/register/success',
        name: 'register-success',
        component: () => import('@/views/RegisterSuccess.vue')
    },
    {
        path: '/logout',
        name: 'logout',
        meta: { previewWithoutSubscription: true }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('@/views/ResetPasswordStep1.vue')
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password-token',
        component: () => import('@/views/ResetPasswordStep2.vue')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('@/views/Search.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/favorites',
        name: 'favorites',
        component: () => import('@/views/Favorites.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/region-info',
        name: 'region-info',
        component: () => import('@/views/Dashboard.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/crops',
        name: 'crops',
        component: () => import('@/views/Crops.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/crop/:id',
        name: 'crop',
        component: () => import('@/views/Crop.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/protectors',
        name: 'protectors',
        component: () => import('@/views/Protectors.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/protector/:id',
        name: 'protector',
        component: () => import('@/views/Protector.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/protector/:id/substitutes',
        name: 'protector-substitutes',
        component: () => import('@/views/Protectors.vue'),
        meta: { requiresAuth: true, isSubstitutes: true },
        props: true
    },
    {
        path: '/agrii-protectors',
        name: 'agrii-protectors',
        component: () => import('@/views/AgriiProtectors.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/agrii-protector/:id',
        name: 'agrii-protector',
        component: () => import('@/views/AgriiProtector.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/agrofags',
        name: 'agrofags',
        component: () => import('@/views/Agrofags.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/agrofag/:id',
        name: 'agrofag',
        component: () => import('@/views/Agrofag.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/active-substances',
        name: 'active-substances',
        component: () => import('@/views/ActiveSubstances.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/active-substance/:id',
        name: 'active-substance',
        component: () => import('@/views/ActiveSubstance.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: () => import('@/views/Notifications.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/photos',
        name: 'photos',
        component: () => import('@/views/Photos.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/alerts',
        name: 'alerts',
        component: () => import('@/views/Alerts.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/alerts/for-approval',
        name: 'alerts-for-approval',
        component: () => import('@/views/AlertsToApprove.vue'),
        meta: {
            requiresAuth: true,
            forAdvisor: true
        }
    },
    {
        path: '/alert/add',
        name: 'alert-add',
        component: () => import('@/views/AlertAdd.vue'),
        meta: {
            requiresAuth: true,
            forAdvisor: true
        }
    },
    {
        path: '/alert/:id',
        name: 'alert',
        component: () => import('@/views/Alert.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/alert/:id/approve',
        name: 'alerts-approve',
        component: () => import('@/views/AlertApprove.vue'),
        meta: {
            requiresAuth: true,
            forAdvisor: true
        }
    },
    {
        path: '/crop-watches',
        name: 'crop-watches',
        // component: () => import('@/views/Dashboard.vue'),
        component: PageNotFound,
        meta: { requiresAuth: true }
    },
    {
        path: '/crop-watches/fill',
        name: 'crop-watches-fill',
        // component: () => import('@/views/Dashboard.vue'),
        component: PageNotFound,
        meta: { requiresAuth: true }
    },
    {
        path: '/crop-watches/fill/:id',
        name: 'crop-watches-fill-details',
        // component: () => import('@/views/Dashboard.vue'),
        component: PageNotFound,
        meta: { requiresAuth: true }
    },
    {
        path: '/users',
        name: 'users',
        component: () => import('@/views/Users.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/user/add',
        name: 'user-add',
        component: () => import('@/views/UserAdd.vue')
    },
    {
        path: '/user/:id',
        name: 'user',
        component: () => import('@/views/User.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/Settings.vue'),
        meta: { requiresAuth: true, previewWithoutSubscription: true }
    },
    {
        path: '/subscriptions',
        component: () => import('@/views/Subscriptions.vue'),
        meta: { requiresAuth: true, previewWithoutSubscription: true },
        children: [
            {
                path: '/',
                name: 'subscriptionsList',
                component: () =>
                    import('@/views/subscriptions/SubscriptionsList.vue'),
                meta: { requiresAuth: true, previewWithoutSubscription: true }
            },
            {
                path: 'payments',
                name: 'subscriptionsPayments',
                component: () =>
                    import('@/views/subscriptions/SubscriptionsPayment'),
                meta: { requiresAuth: true, previewWithoutSubscription: true }
            },
            {
                path: 'active',
                name: 'subscriptionDetails',
                component: () =>
                    import('@/views/subscriptions/SubscriptionDetails'),
                meta: { requiresAuth: true, previewWithoutSubscription: true }
            }
        ]
    },
    {
        path: '/regulamin',
        name: 'termsAndConditions',
        component: () => import('@/views/TermsAndConditions.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/invoices',
        name: 'invoices',
        component: () => import('@/views/Invoices.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/Contact.vue'),
        meta: { requiresAuth: true }
    },

    {
        path: '/paymentStatus',
        name: 'paymentStatus',
        component: () => import('@/views/PaymentStatus.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/*',
        name: 'error404',
        component: PageNotFound
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    // hide menu
    if (store.getters.menuStatus) {
        store.dispatch('hideMenu')
    }

    // logout
    if (to.name === 'logout') {
        store.dispatch('authLogout').then(() => {
            if (to.params.code) {
                if (to.params.code === 403) {
                    store.dispatch('addNotification', {
                        type: 'info',
                        content: 'Twoja sesja wygasła, zaloguj się ponownie'
                    })
                }
            } else {
                store.dispatch('addNotification', {
                    type: 'info',
                    content: 'Wylogowano'
                })
            }
            next({ name: 'login' })
        })
    }

    // go to dashboard if logged in
    if (to.name === 'login') {
        store
            .dispatch('authCheckTokenValidity')
            .then(() => {
                router.push({ name: 'dashboard' })
            })
            .catch(() => {})
    }

    // guard for routes with requireAuth attr
    // check for token on 404 page to redirect user
    // from 404 to dashboard (if logged) or login page (if logged out)
    if (to.meta.requiresAuth || to.name === 'error404') {
        store
            .dispatch('authCheckTokenValidity')
            .then(() => {
                if (!to.meta.forAdvisor || store.getters.authIsAdvisor) {
                    // check if user has agreed to T&C if not redirect to terms page
                    if (store.getters['termsAndConditions/accepted']) {
                        next()
                    } else {
                        router.push({ name: 'termsAndConditions' })
                    }
                } else {
                    router.push({ name: 'logout', params: { code: 401 } })
                }
            })
            .catch(() => {
                if (to.name !== 'error404') {
                    router.push({ name: 'logout', params: { code: 403 } })
                } else {
                    next()
                }
            })
    } else {
        next()
    }

    // scroll to top
    window.scrollTo(0, 0)

    // check eko status
    store.dispatch('eko/fetchFromStorage')
    // handle user subscription
    if (to.name === 'login' || to.name === 'logout') {
        store.dispatch('announcements/closeNoSubscriptionAnnouncement')
    }
    if (to.meta.requiresAuth) {
        await store.dispatch('subscriptions/fetchActiveSubscription')
        if (store.getters['subscriptions/userHasActiveSubscription']) {
            store.dispatch('announcements/closeNoSubscriptionAnnouncement')
        } else {
            store.dispatch('announcements/openNoSubscriptionAnnouncement')
            if (!to.meta.previewWithoutSubscription) {
                router.push({ name: 'subscriptionsList' })
            }
        }
    }
})

export default router
